// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Target } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconTarget(props: any) {
    return <IconBase icon={Target} {...props} />
  }

  export default IconTarget
  